"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = exports.getTranslatedErrorMessageWithParams = exports.getTranslatedErrorMessage = void 0;
var utils_1 = require("../../internal/utils");
var i18next_1 = __importDefault(require("i18next"));
// Handling keys without params
var errorMessages = {
    required: {
        key: 'validations[SEPARATOR]input.blank',
        fallback: 'This field cannot be left blank.',
    },
    validEmail: {
        key: 'validations[SEPARATOR]input.email.valid',
        fallback: 'Please type a valid email format.',
    },
    requiredEmail: {
        key: 'validations[SEPARATOR]input.email.required',
        fallback: 'Email is a required field',
    },
    matchPassword: {
        key: 'validations[SEPARATOR]input.password.match',
        fallback: 'Password fields should match.',
    },
    acceptTerms: {
        key: 'validations[SEPARATOR]input.acceptedTos',
        fallback: 'Please agree to the terms and privacy policy to continue.',
    },
    requiredPassword: {
        key: 'validations[SEPARATOR]input.password.required',
        fallback: 'Password is a required field',
    },
    incorrectPasswordFormat: {
        key: 'validations[SEPARATOR]input.password.incorrect',
        fallback: 'Incorrect password format.',
    },
    passwordsDontMatch: {
        key: 'validations[SEPARATOR]input.password.dontMatch',
        fallback: "Passwords don't match",
    },
    invalidCode: {
        key: 'validations[SEPARATOR]input.code.invalid',
        fallback: 'This code is invalid',
    },
    incorrectNumberOfCodeDigits: {
        key: 'validations[SEPARATOR]input.code.incorrect',
        fallback: 'This code has an incorrect number of digits',
    },
    validPhone: {
        key: 'validations[SEPARATOR]input.phone.valid',
        fallback: 'Please type a valid phone number.',
    },
    validDate: {
        key: 'validations[SEPARATOR]input.date.valid',
        fallback: 'Please type a valid date format.',
    },
    validTime: {
        key: 'validations[SEPARATOR]input.time.valid',
        fallback: 'Please insert a valid time',
    },
    endDateAfterStartDate: {
        key: 'validations[SEPARATOR]input.date.afterStart',
        fallback: 'End date must be after start date',
    },
    endDateFuture: {
        key: 'validations[SEPARATOR]input.date.future',
        fallback: 'End date must be in the future',
    },
    timeNotInFuture: {
        key: 'validations[SEPARATOR]input.time.notInFuture',
        fallback: 'Entry cannot be a time in the future',
    },
    validDecimal: {
        key: 'validations[SEPARATOR]input.decimal',
        fallback: 'Please type a valid decimal value',
    },
    validBhb: {
        key: 'validations[SEPARATOR]input.bhb',
        fallback: 'Your BHB value needs to be higher than 0',
    },
    validZip: {
        key: 'validations[SEPARATOR]input.zip',
        fallback: 'Zip code must be exactly 5 numbers',
    },
    validOtp: {
        key: 'validations[SEPARATOR]input.otp.valid',
        fallback: 'This code has an incorrect number of digits',
    },
    validOtpCode: {
        key: 'validations[SEPARATOR]input.otp.validCode',
        fallback: 'Invalid code. Try resending it.',
    },
    atLeastOneKey: {
        key: 'validations[SEPARATOR]input.atLeastOneKey',
        fallback: 'At least one key must have a value',
    },
};
/**
 * Returns the translated error message
 * @param key - i18n key of the error message
 * @param systemType - wether the system is mobile or web
 * @returns translated error message
 */
var getTranslatedErrorMessage = function (key, systemType) {
    var i18nFirstSeparator = (0, utils_1.getI18nFirstSeparator)(systemType);
    var i18nKey = errorMessages[key].key.replace('[SEPARATOR]', i18nFirstSeparator);
    return i18next_1.default.t(i18nKey, errorMessages[key].fallback);
};
exports.getTranslatedErrorMessage = getTranslatedErrorMessage;
var errorMessagesWithParams = {
    decimalBetweenRange: function (params) { return ({
        key: 'validations[SEPARATOR]input.decimalRange',
        fallback: "Please insert a value between ".concat(params === null || params === void 0 ? void 0 : params.min, " - ").concat(params === null || params === void 0 ? void 0 : params.max, " ").concat(params === null || params === void 0 ? void 0 : params.unit),
    }); },
};
/**
 * Returns the translated error message with params
 * @param key - i18n key of the error message
 * @param systemType - wether the system is mobile or web
 * @param params - params to be inserted in the error message
 * @returns translated error message
 */
var getTranslatedErrorMessageWithParams = function (key, systemType, params) {
    var i18nFirstSeparator = (0, utils_1.getI18nFirstSeparator)(systemType);
    var i18nValue = errorMessagesWithParams[key](params);
    var i18nKey = i18nValue.key.replace('[SEPARATOR]', i18nFirstSeparator);
    return i18next_1.default.t(i18nKey, i18nValue.fallback, params);
};
exports.getTranslatedErrorMessageWithParams = getTranslatedErrorMessageWithParams;
// Handling errors without translation
/**
 * Returns error message without translation
 * @param key - key of the error message
 * @returns error message
 */
var getErrorMessage = function (key) {
    return errorMessages[key].fallback;
};
exports.getErrorMessage = getErrorMessage;
